import Flickity from 'flickity';
import zenscroll from 'zenscroll';
import Cookies from 'js-cookie';
// import Shake from 'shake.js';
// import { isMobile, isTablet } from 'mobile-device-detect';

import '../polyfills/closest';
import Button from './Button';
import Validate from './Validate';

const FF = {
  elem: document.querySelector('.js-festive-fusions'),
  bgLeft: document.querySelector('.js-bg-left'),
  bgRight: document.querySelector('.js-bg-right'),
  firstForm: document.querySelector('#js-first-form'),
  secondForm: document.querySelector('#js-second-form'),
  firstFormError: document.querySelector('.js-first-form-error'),
  secondFormError: document.querySelector('.js-second-form-error'),
  sectionTriggers: document.querySelectorAll('[data-section-trigger]'),
  mobileFooterEl: document.querySelector('.ff__background-image--footer'),
  ingredients: document.querySelectorAll('[data-ingredient]'),
  mixingEl: document.querySelector('.js-mixing'),
  mixingPlaceholderEl: document.querySelector('.js-mixing-placeholder'),
  clickToMixBtn: document.querySelector('.js-click-to-mix'),
  bottleLabel: document.querySelector('.js-bottle-label'),
  isMotionPermitedValue: false,
  selected: {
    top: null,
    mid: null,
    base: null
  },
  formData: null,
  recaptchaContainer: document.querySelector('.js-recaptcha-container'),
  endpoint: 'https://campaigns.zoflora.co.uk/api/entries/insert',
  //
  isDev: false,

  init() {
    this.render();
  },

  setCookie(name, value, path) {
    let expires = '';
    const date = new Date();
    const midnight = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      23,
      59,
      59
    );

    expires = '; expires=' + midnight.toGMTString();
    if (!path) path = '/';
    document.cookie = name + '=' + value + expires + '; path=' + path;
  },

  prepareFormData(form) {
    const data = {};
    // data.CampaignId = campaignId.value;

    for (let i = 0; i < form.elements.length; i++) {
      if (form.elements[i].type === 'checkbox') {
        data[form.elements[i].name] = form.elements[i].checked ? true : false;
      } else {
        data[form.elements[i].name] = form.elements[i].value;
      }
    }
    delete data[''];

    return data;
  },

  handleFirstForm(event) {
    event.preventDefault();

    const cookieVal = Cookies.get('ff-has-played');
    const emailField = document.querySelector('#firstName');
    const preStartTrigger = document.querySelector(
      '[data-section-trigger="game-1"]'
    );

    if (FF.isDev) {
      FF.switchSection(preStartTrigger);
      return;
    }

    if (cookieVal && Number(cookieVal) >= 3) {
      FF.firstFormError.innerHTML =
        'You have entered 3 times today, please come back tomorrow.';
      return;
    }

    if (emailField.value.length > 10) {
      FF.firstFormError.innerHTML =
        'First name field cannot be more than 10 characters.';
      return;
    }

    const form = event.target;
    const parseForm = Validate.parseForm(event.target);
    if (!parseForm) return;
    const data = FF.prepareFormData(form);

    data.addressLine1 = '';
    data.addressLine2 = '';
    data.postcode = '';
    FF.formData = data;

    FF.switchSection(preStartTrigger);
  },

  handleSecondForm(event) {
    event.preventDefault();

    const cookieVal = Cookies.get('ff-has-played');
    const preStartTrigger = document.querySelector(
      '[data-section-trigger="mixing"]'
    );

    if (FF.isDev) {
      FF.switchSection(preStartTrigger);
      return;
    }

    if (window.grecaptcha) {
      window.grecaptcha.ready(function() {
        window.grecaptcha
          .execute('6Le-vv8ZAAAAAH99zZJnazUb4H9Dpg8WjCMJ-pTI', {
            action: 'submit'
          })
          .then(function(token) {
            const form = event.target;
            const parseForm = Validate.parseForm(event.target);
            if (!parseForm) return;
            const data = FF.prepareFormData(form);

            FF.formData.campaignId = data.campaignId;
            FF.formData.optIn = data.optIn;
            FF.formData.termsAndConditions = data.termsAndConditions;
            FF.formData.recaptchaToken = token;
            FF.bottleLabel.innerHTML = `${FF.formData.firstName}'s Fragrance`;

            FF.formData.answers.push({
              Question: 3,
              Value: data.inspired
            });

            FF.formData.answers.push({
              Question: 4,
              Value: data.top
            });

            FF.formData.answers.push({
              Question: 5,
              Value: data.mid
            });

            FF.formData.answers.push({
              Question: 6,
              Value: data.base
            });

            FF.secondFormError.innerHTML = '';

            const action = async () => {
              const response = await fetch(`${FF.endpoint}`, {
                method: 'post',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(FF.formData)
              })
                .then(res => {
                  Button.reset('btn-mix');

                  // Success
                  if (res.status === 200) {
                    FF.switchSection(preStartTrigger);
                    return res;
                  }

                  if (res.status === 400) {
                    FF.secondFormError.innerHTML =
                      'There was an issue, please try again.';
                    if (window.grecaptcha) window.grecaptcha.reset();
                    return res;
                  }

                  if (res.status === 401) {
                    FF.secondFormError.innerHTML =
                      'Recaptcha expired, please try again.';
                    if (window.grecaptcha) window.grecaptcha.reset();
                    return res;
                  }
                })
                .catch(err => {
                  FF.secondFormError.innerHTML =
                    'There was an issue, please try again.';
                  if (window.grecaptcha) window.grecaptcha.reset();
                  console.error(err);
                });

              if (!response) return;

              if (cookieVal) {
                FF.setCookie('ff-has-played', Number(cookieVal) + 1, null);
              } else {
                FF.setCookie('ff-has-played', 1, null);
              }
              // const res = await response.json();
            };

            Button.toggleLoading('btn-mix');
            action();
          });
      });
    } else {
      FF.secondFormError.innerHTML = 'Recaptcha not found, please try again.';
    }
  },

  handleBottleImageEffect() {
    const nextSection = document.querySelector(
      '[data-section-trigger="final"]'
    );

    FF.mixingEl.src = './static/images/bottle/bottle.gif';
    FF.mixingEl.classList.remove('dn');

    setTimeout(() => {
      FF.switchSection(nextSection);
    }, 3500);
  },

  // handleBottleShake() {
  //   const shakeEvent = new Shake({ threshold: 15 });
  //
  //   shakeEvent.start();
  //
  //   window.addEventListener(
  //     'shake',
  //     function(e) {
  //       e.preventDefault();
  //       FF.handleBottleImageEffect();
  //       shakeEvent.stop();
  //     },
  //     false
  //   );
  // },

  switchSection(trigger) {
    if (trigger?.disabled) {
      return;
    }

    const nextSectionNumber = trigger.getAttribute('data-section-trigger');
    const currentSection = trigger.closest('[data-section]');
    const nextSection = document.querySelector(
      `[data-section="${nextSectionNumber}"]`
    );

    const hideCurrent = () => {
      return new Promise(resolve => {
        currentSection.classList.remove('ff__fade-in');
        currentSection.classList.add('ff__fade-out');
        FF.mobileFooterEl.style.opacity = 0;

        setTimeout(() => {
          currentSection.classList.add('ff__is-hidden');
          resolve();
        }, 300);
      });
    };

    const showNext = () => {
      return new Promise(resolve => {
        nextSection.classList.remove('ff__is-hidden');

        setTimeout(() => {
          currentSection.classList.remove('ff__fade-out');
          nextSection.classList.add('ff__fade-in');
          FF.mobileFooterEl.style.opacity = 1;

          resolve();
        }, 300);
      });
    };

    const action = async () => {
      await hideCurrent();
      if (nextSection) await showNext();
    };

    action();

    // if (nextSectionNumber === 'game-1') {
    //   if (
    //     typeof DeviceMotionEvent !== 'undefined' &&
    //     typeof DeviceMotionEvent.requestPermission === 'function'
    //   ) {
    //     DeviceMotionEvent.requestPermission()
    //       .then(permissionState => {
    //         if (permissionState === 'granted') {
    //           FF.isMotionPermitedValue = true;
    //           window.addEventListener('devicemotion', e => {
    //             e.preventDefault();
    //           });
    //         }
    //       })
    //       .catch(console.error);
    //   }
    // }

    if (
      nextSectionNumber === 'game-1' ||
      nextSectionNumber === 'game-2' ||
      nextSectionNumber === 'game-3'
    ) {
      const carouselEl = nextSection.querySelector('.js-carousel');
      const carousel = Flickity.data(carouselEl);

      setTimeout(() => {
        FF.bgLeft.style.opacity = 1;
        FF.bgRight.style.opacity = 1;
      }, 600);

      setTimeout(() => {
        carousel.resize();
        FF.carouselEvents(carousel);
      }, 350);
    }

    // if (nextSectionNumber === 'end-form' || nextSectionNumber === 'mixing' || nextSectionNumber === 'final') {
    //   FF.bgLeft.style.opacity = 0;
    //   FF.bgRight.style.opacity = 0;
    //
    //   setTimeout(() => {
    //     FF.bgLeft.style.opacity = 1;
    //     FF.bgRight.style.opacity = 1;
    //   }, 600);
    // }

    if (nextSectionNumber === 'end-form') {
      if (FF.formData) {
        // if (window.grecaptcha) {
        //   window.grecaptcha.render(FF.recaptchaContainer, {
        //     sitekey: '6Ldyj68ZAAAAAEwUGhzZwy9THd5JTjgujl6USd2S'
        //   });
        // }

        FF.formData.answers = [];

        const keys = Object.keys(FF.selected);

        keys.forEach((key, index) => {
          const obj = {
            Question: index,
            Value: FF.selected[key]
          };

          FF.formData.answers.push(obj);
        });
      }
    }

    if (nextSectionNumber === 'mixing') {
      setTimeout(() => {
        FF.firstForm.innerHTML = '';
        FF.secondForm.innerHTML = '';

        // if (isMobile && !isTablet && FF.isMotionPermitedValue) {
        //   FF.handleBottleShake();
        // } else {
        //   FF.handleBottleImageEffect();
        // }
      }, 350);
    }

    zenscroll.to(FF.elem, 300);
  },

  carouselEvents(carousel) {
    carousel.on('staticClick', function(
      event,
      pointer,
      cellElement,
      cellIndex
    ) {
      FF.handleIngredientClick(cellElement);
    });
  },

  handleIngredientClick(el) {
    const item = el.querySelector('.ff__ingredient');
    const selectedWrappers = document.querySelectorAll(
      '.ff__ingredient__wrapper.selected'
    );
    const wrapper = item.closest('.ff__ingredient__wrapper');
    const currentSection = item.closest('[data-section]');
    const itemImage = item.src;
    const ingredient = item.getAttribute('data-ingredient');
    const ingredientType = item.getAttribute('data-ingredient-type');
    const nextButton = currentSection.querySelector('.js-next-button');
    const selectedPlaceholder = document.querySelectorAll(
      `[data-ingredient-selected="${ingredientType}"]`
    );

    // Remove selected from all wrappers
    for (let i = 0; i < selectedWrappers.length; i++) {
      selectedWrappers[i].classList.remove('selected');
    }

    FF.selected[ingredientType] = ingredient;
    wrapper.classList.add('selected');
    nextButton.disabled = false;

    for (let i = 0; i < selectedPlaceholder.length; i++) {
      selectedPlaceholder[i].style.backgroundImage = `url(${itemImage})`;
    }
  },

  render() {
    if (!this.elem) {
      return;
    }

    FF.firstForm.addEventListener('submit', FF.handleFirstForm, false);
    FF.secondForm.addEventListener('submit', FF.handleSecondForm, false);

    FF.clickToMixBtn.addEventListener(
      'click',
      FF.handleBottleImageEffect,
      false
    );

    for (let i = 0; i < FF.sectionTriggers.length; i += 1) {
      FF.sectionTriggers[i].addEventListener(
        'click',
        () => {
          FF.switchSection(FF.sectionTriggers[i]);
        },
        false
      );
    }
  }
};

export default FF;
